module.exports = __webpack_public_path__ + "static/media/Geomanist-Medium.996e7927.otf";